// This component is made duplication from ModalDialogButton component using Polaris V3.
// TODO - Start working to deprecate ModalDialogButton to use this instead.
import {
  Box,
  Button,
  ButtonProps,
  IconProps,
  Link,
  Modal,
  ModalProps,
  SpaceBetween,
} from '@amzn/awsui-components-core';
import React, { type JSX } from 'react';
import constants from '../../common/constants';

interface ModalDialogButtonV3Props {
  className?: string;
  variant?: 'normal' | 'primary' | 'icon' | 'text' | 'link';
  iconName?: IconProps.Name | null;
  iconUrl?: string | null;
  iconAlign?: ButtonProps.IconAlign;
  header?: string;
  text?: string;
  onBeforeOpenModal?: () => Promise<boolean>;
  onCloseModal?: () => void;
  buttonText?: string;
  cancelText?: string;
  submitButtonText?: string;
  onSubmit?: () => void;
  disabled?: boolean;
  inputForm?: () => JSX.Element;
  inputValid?: boolean;
  actionControls?: boolean;
  visible?: boolean;
  loading?: boolean;
  onDismiss?: () => void;
  fullwidth?: boolean;
  size?: ModalProps.Size;
  dataTestId?: string;
  readonly children?: React.ReactNode;
}

interface ModalDialogButtonV3State {
  isModalOpen: boolean;
  isSubmitting: boolean;
}

class ModalDialogButtonV3 extends React.Component<
  ModalDialogButtonV3Props,
  ModalDialogButtonV3State
> {
  static defaultProps = {
    actionControls: true,
    disabled: false,
    iconAlign: 'right',
    inputValid: true,
    loading: false,
    visible: true,
  };
  constructor(props: ModalDialogButtonV3Props) {
    super(props);
    this.state = {
      isModalOpen: false,
      isSubmitting: false,
    };
  }

  public render() {
    const {
      buttonText,
      submitButtonText,
      text,
      header,
      variant,
      iconName,
      iconUrl,
      iconAlign,
      disabled,
      inputForm,
      inputValid,
      actionControls,
      cancelText,
      visible,
      loading,
      fullwidth,
      size,
      className,
      dataTestId,
    } = this.props;

    if (!visible) {
      return null;
    }

    const { isModalOpen, isSubmitting } = this.state;

    const actionButtons = actionControls ? (
      <Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="link" onClick={this.cancel}>
            {cancelText ? cancelText : constants.CANCEL_BUTTON_TEXT}
          </Button>
          <Button
            variant="primary"
            onClick={this.submit}
            loading={isSubmitting}
            disabled={!inputValid}
          >
            {submitButtonText || 'Submit'}
          </Button>
        </SpaceBetween>
      </Box>
    ) : null;

    const modalContent = (
      <div>
        {text}
        {inputForm && inputForm()}
        {this.props.children}
      </div>
    );

    const btn =
      variant === 'text' ? (
        <Box padding={{ left: 's' }}>
          <Link variant="secondary" onClick={this.openModal}>
            {buttonText || submitButtonText}
          </Link>
        </Box>
      ) : (
        <Button
          variant={variant || 'normal'}
          // @ts-expect-error TS2322 - strict migration
          iconName={iconName}
          // @ts-expect-error TS2322 - strict migration
          iconUrl={iconUrl}
          iconAlign={iconAlign}
          onClick={this.openModal}
          disabled={disabled}
          loading={loading}
          fullWidth={!!className || fullwidth}
          iconAlt={iconName || iconUrl ? 'Icon' : undefined}
        >
          {buttonText || submitButtonText}
        </Button>
      );

    return (
      <Box>
        <Modal
          data-testid={`${dataTestId}${isModalOpen ? '' : '-hidden'}`}
          header={header}
          visible={isModalOpen}
          onDismiss={this.closeModal}
          footer={actionButtons}
          size={size || 'medium'}
          closeAriaLabel="Close modal"
        >
          {modalContent}
        </Modal>
        {btn}
      </Box>
    );
  }

  private submit = async () => {
    this.setState({
      isSubmitting: true,
    });

    try {
      const { onSubmit } = this.props;
      if (onSubmit) {
        await onSubmit();
      }
    } finally {
      this.setState({
        isSubmitting: false,
      });
      this.closeModal();
    }
  };

  private cancel = () => {
    const { onCloseModal } = this.props;
    try {
      if (onCloseModal) {
        onCloseModal();
      }
    } finally {
      this.closeModal();
    }
  };

  private openModal = async () => {
    const { onBeforeOpenModal } = this.props;
    if (!onBeforeOpenModal || (await onBeforeOpenModal())) {
      this.setState({
        isModalOpen: true,
      });
    }
  };

  private closeModal = () => {
    this.setState({
      isModalOpen: false,
    });
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  };
}

export default ModalDialogButtonV3;
